import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

function EditSummaryBook() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [book, setBook] = useState({
        title: '',
        author: '',
        categories: [],
        image_url: '',
        cefrLevel: 'A1'
    });

    const categoriesList = [
        'Fiction', 'Non-Fiction', 'Fantasy', 'Science Fiction',
        'Mystery', 'Thriller', 'Romance', 'Biography',
        'History', 'Children', 'Young Adult', 'Poetry',
        'Drama', 'Adventure', 'Horror', 'Self-Help',
        'Business', 'Science', 'Philosophy', 'Religion','Psychology'
    ];

    const cefrLevels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

    useEffect(() => {
        const fetchBook = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/summary-book/${id}`);
                setBook({
                    title: response.data.title || '',
                    author: response.data.author || '',
                    categories: response.data.categories || [],
                    image_url: response.data.image_url || '',
                    cefrLevel: response.data.cefrLevel || 'A1'
                });
            } catch (error) {
                console.error("Error fetching book:", error);
                toast.error("Failed to load book data");
            }
        };
        fetchBook();
    }, [id]);

    const handleChange = (e) => {
        setBook({ ...book, [e.target.name]: e.target.value });
    };

    const handleCategoriesChange = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
        setBook({ ...book, categories: selectedOptions });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/summary-book/${id}`, book);
            if (response.data.success) {
                toast.success("Summary book updated successfully!");
                navigate('/summary-books');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Update error:", error);
            toast.error("Failed to update summary book");
        }
    };

    return (
        <>
            <Navbar />
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card shadow">
                            <div className="card-header bg-warning">
                                <h3 className="mb-0">Edit Summary Book</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleUpdate}>
                                    <div className="mb-3">
                                        <label className="form-label">Title *</label>
                                        <input type="text" className="form-control" name="title" value={book.title} onChange={handleChange} required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Author *</label>
                                        <input type="text" className="form-control" name="author" value={book.author} onChange={handleChange} required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Categories (Select multiple)</label>
                                        <select className="form-select" name="categories" multiple size="5" value={book.categories} onChange={handleCategoriesChange}>
                                            {categoriesList.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                                        </select>
                                        <small className="text-muted">Hold Ctrl (Windows) or Cmd (Mac) to select multiple</small>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Image URL</label>
                                        <input type="text" className="form-control" name="image_url" value={book.image_url} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">CEFR Level</label>
                                        <select className="form-select" name="cefrLevel" value={book.cefrLevel} onChange={handleChange}>
                                            {cefrLevels.map(level => <option key={level} value={level}>{level}</option>)}
                                        </select>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <button type="submit" className="btn btn-warning">Update Summary Book</button>
                                        <button type="button" className="btn btn-secondary" onClick={() => navigate('/summary-books')}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default EditSummaryBook;